import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar.jsx";
import TopBar from "./topbar.jsx";

/**
 * Shell for every authenticated HQ page: persistent left sidebar + top header
 * bar + scrollable main content. Use as a layout route in App.jsx so every
 * nested route automatically gets the navbar without importing it manually.
 */
export default function AppLayout() {
  return (
    <div className="flex h-[100dvh] bg-[#0A1628] text-[#E8EFF7]">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <TopBar />
        <main className="flex-1 overflow-y-auto">
          <div className="w-full px-8 py-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
